import type { ReactElement } from 'react';

import type { SidebarNavItem } from '../types';

import SidebarCountBadge from './SidebarCountBadge';
import SidebarNewTag from './SidebarNewTag';
import SidebarPlusTag from './SidebarPlusTag';
import WhatsNewDot from './WhatsNewDot';

/** The one marker at the end of a sidebar item: a count, a Plus+ tag, the What's New dot or "New". */
export default function SidebarItemTag({ item }: { item: SidebarNavItem }): ReactElement | null {
  if (item.badge && !isNewPlaceholder(item)) return <SidebarCountBadge count={item.badge.title} />;
  if (item.plusFeature) {
    return <SidebarPlusTag feature={item.plusFeature} fallback={item.new && <SidebarNewTag />} />;
  }
  if (item.unreadDot) return <WhatsNewDot />;
  if (item.new) return <SidebarNewTag />;

  return null;
}

// `navigationSlice` gives a new page a "New" badge while it has no count; the sidebar shows that as
// the "New" tag, not as a count.
function isNewPlaceholder(item: SidebarNavItem): boolean {
  return Boolean(item.new) && item.badge?.title === 'New';
}
